import { render, staticRenderFns } from "./InPendingArticles.vue?vue&type=template&id=86587722&scoped=true"
import script from "./InPendingArticles.vue?vue&type=script&lang=js"
export * from "./InPendingArticles.vue?vue&type=script&lang=js"
import style0 from "./InPendingArticles.vue?vue&type=style&index=0&id=86587722&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86587722",
  null
  
)

export default component.exports